module.exports = __webpack_public_path__ + "img/home_creative-image2.4bedffff.jpg";